export class Inventory {
  private items: Map<number, number> = new Map();
  onChange?: () => void;

  add(itemId: number, count: number = 1): void {
    this.items.set(itemId, (this.items.get(itemId) || 0) + count);
    this.onChange?.();
  }

  remove(itemId: number, count: number = 1): boolean {
    const current = this.items.get(itemId) || 0;
    if (current < count) return false;
    const remaining = current - count;
    if (remaining <= 0) {
      this.items.delete(itemId);
    } else {
      this.items.set(itemId, remaining);
    }
    this.onChange?.();
    return true;
  }

  has(itemId: number, count: number = 1): boolean {
    return (this.items.get(itemId) || 0) >= count;
  }

  getCount(itemId: number): number {
    return this.items.get(itemId) || 0;
  }

  getAll(): Map<number, number> {
    return new Map(this.items);
  }

  loadItems(data: Record<string, number>) {
    this.items.clear();
    for (const [key, count] of Object.entries(data)) {
      const id = Number(key);
      if (id > 0 && count > 0) {
        this.items.set(id, count);
      }
    }
  }

  toJSON(): Record<string, number> {
    const obj: Record<string, number> = {};
    for (const [id, count] of this.items) {
      obj[String(id)] = count;
    }
    return obj;
  }

  static fromJSON(data: Record<string, number>): Inventory {
    const inv = new Inventory();
    for (const [key, count] of Object.entries(data)) {
      const id = Number(key);
      if (id > 0 && count > 0) {
        inv.items.set(id, count);
      }
    }
    return inv;
  }
}
